// Firebase configuration — HardwarePOS
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: "AIzaSyD_EGAc8nVt50TtptfG5zoNAYR5DZV21Dc",
    authDomain: "pos1-3dffc.firebaseapp.com",
    projectId: "pos1-3dffc",
    storageBucket: "pos1-3dffc.firebasestorage.app",
    messagingSenderId: "659460639020",
    appId: "1:659460639020:web:4d67af31595930b6f24489",
    measurementId: "G-GSY7C5T5SM",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
    ignoreUndefinedProperties: true,
    localCache: persistentLocalCache({
        tabManager: persistentMultipleTabManager(),
    }),
});
export const functions = getFunctions(app);

// Initialize Analytics (only in browser, not SSR)
isSupported().then((supported) => {
    if (supported) getAnalytics(app);
});

export default app;
